import * as React from 'react';
import { Component } from 'react';
import Moment from 'moment';
import { AppUser } from 'Src/views/App/App';
import './SchoolEventTabs.scss';
import { SchoolEventGroupedTabs } from './SchoolEventGroupedTabs';
import { LazyEventCommunications as EventCommunications } from 'Src/components/EventCommunications/LazyEventCommunications';
import { getEventPlayers, getEventViewTabs } from 'Src/helpers/event/event';
import { EmptyComponent } from 'Src/components/EmptyComponent/EmptyComponent';
import { TABS } from 'Src/consts/common';
import { SchoolEventDetailsSummary } from 'Src/components/SchoolEventDetailsSummary/SchoolEventDetailsSummary';
import { SchoolEventJobsSummary } from 'Src/components/SchoolEventJobsSummary/SchoolEventJobsSummary';
import { SchoolEventPerformanceSummary } from 'Src/components/SchoolEventPerformanceSummary/SchoolEventPerformanceSummary';
import { SchoolEventAttendanceSummary } from 'Src/components/SchoolEventAttendance/SchoolEventAttendanceSummary';
import { SchoolEventKitSummary } from 'Src/components/SchoolEventKitSummary/SchoolEventKitSummary';
import {
  batchEventAttendance,
  batchEventPerformance,
  getSchoolEventDetails,
  onDeleteJob,
  updateSchoolEventDetails
} from 'Src/helpers/service/admin/schoolEvents';
import { Loader } from 'Src/components/Loader/Loader';
import { createEventTasks, editEventTasks, getEventTasks, getSchoolEvent } from 'Src/helpers/service/admin/event';
import { Button } from 'Src/components/Button/Button';
import propz from 'propz';
import BPromise from 'bluebird';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { SchoolEventJobForm } from '../SchoolEventJobForm/SchoolEventJobForm';
import { SchoolEventDetailsForm } from '../SchoolEventDetailsForm/SchoolEventDetailsForm';
import { SchoolEventTeamsTab } from './SchoolEventTeamsTab';
import { isClubEvent, isHousesEvent, isNonTeamSportEvent } from '../../../../../../helpers/event/event';
import { History } from 'history';
import { EventGallery } from './Gallery/Gallery';
import { Video } from '../../../../../../models/video';
import { Photo } from '../../../../../../models/photo';
import { ACCESS_PRESET } from '../../../../../../consts/album';
import { getKey } from 'Src/helpers/service/nobody/key';
import { getVideoConfig } from 'Src/helpers/service/nobody/config';
import S3 = require('aws-sdk/clients/s3');
import { EventVideos } from './Videos/EventVideos';
import { addConvertJob } from 'Src/helpers/service/nobody/aws';
import {
  addEventPhoto,
  deleteEventPhoto,
  getAllEventPhotos,
  updateEventPhoto
} from 'Src/helpers/service/admin/eventPhotos';
import {
  addEventVideo,
  deleteEventVideo,
  getAllEventVideos,
  updateEventVideo
} from 'Src/helpers/service/admin/eventVideos';
import { ACCESS_PRESET_TYPE } from '../../../../../../types/album';
import { SchoolEventMatchReportSummary } from '../../../../../../components/SchoolEventMatchReportSummary/SchoolEventMatchReportSummary';
import {
  batchEventDiscipline,
  getSchoolEventMatchReport,
  updateGroupSchoolEventDetails,
  updateSchoolEventMatchReport
} from '../../../../../../helpers/service/admin/schoolEvents';
import { uploadImage } from '../../../../../../helpers/service/image';
import { getSafeFileName } from '../../../../../../helpers/file/file';
import {
  doGotItActionForEventMessage,
  getAvailabilityReports,
  getEventAvailabilityWorkflow,
  getParentalConsent
} from '../../../../../../helpers/service/admin/messages';
import { SchoolEventAvailabilityReportsSummary } from '../../../../../../components/SchoolEventAvailabilityReportsSummary/SchoolEventAvailabilityReportsSummary';
import { VenueView } from '../../../../../../components/VenueView/VenueView';
import { Report } from '../../../../../../models/report';
import { Point } from '../../../../../../models/venue';
import { SchoolParentalConsentSummary } from '../../../../../../components/SchoolParentalConsentSummary/SchoolParentalConsentSummary';
import { getPlayers } from '../../../../../../helpers/team/team';
import {
  SchoolEventPlayersSummary,
  SchoolEventPlayerSummary,
  SchoolEventTeamSummary
} from '../../../../../../components/SchoolEventPlayersSummary/SchoolEventPlayersSummary';
import { Sport } from '../../../../../../models/sport';
import { updateSchoolEventTeamPlayersBatch } from '../../../../../../helpers/service/admin/event';
import { getSchoolSports } from '../../../../../../helpers/service/admin/user';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../../../../consts/table';
import { CLUB_EVENT_EDIT_MODE } from '../../../../../../consts/event';
import { updateSchoolEventIndividualsBatch } from '../../../../../../helpers/service/admin/schoolEventIndividuals';
import {
  Participant,
  SchoolEvent,
  SchoolEventAttendance,
  SchoolEventIndividualData,
  SchoolEventIndividualDiscipline,
  SchoolEventIndividualPerformance,
  SchoolEventTeamDataPlayer
} from '../../../../../../models/event';
import { SchoolEventDisciplineSummary } from '../../../../../../components/SchoolEventDisciplineSummary/SchoolEventDisciplineSummary';
import { getEventAwardEvents, AwardEvent, AwardType } from 'Src/helpers/service/admin/awards';
import { getAllAwardTypes, createAwardType } from 'Src/helpers/service/admin/awardTypes';
import { updateAwardEvent, deleteAwardEvent } from 'Src/helpers/service/admin/awards';
import { AwardEventForm, AwardEventFormValues } from '../../../AwardEvents/AwardEventForm/AwardEventForm';
import { GrantAwardModal, StudentLite } from 'Src/components/GrantAwardModal/GrantAwardModal';
import { ModuleUpsellModal } from 'Src/components/ModuleUpsellModal/ModuleUpsellModal';
import { isModuleActiveFresh } from 'Src/helpers/modules/moduleHelpers';
import { getSchoolAwardTypes } from 'Src/helpers/service/admin/awards';
import { getAllSchoolStudents } from 'Src/helpers/service/admin/students';
import { getAllForms } from 'Src/helpers/service/admin/forms';
import { getAllHouses } from 'Src/helpers/service/admin/houses';
import { AttendanceLogModal } from 'Src/components/AttendanceLogModal/AttendanceLogModal';
import { SchoolEventAwardsSummary } from 'Src/components/SchoolEventAwardsSummary/SchoolEventAwardsSummary';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faVideo } from '@fortawesome/free-solid-svg-icons';
import { KIND } from 'Src/consts/school';

interface Props {
  user: AppUser;
  history: History;
  eventInitial: SchoolEvent;
  participants?: Participant[];
  reloadEvent: (tabIndex: number) => void;
  tabIndex: number;
  dataOnlyRefreshVersion?: number;
  onRemoveParticipantClick: (participant: Participant, isOneParticipant: boolean) => void;
  canRemoveParticipants?: boolean;
  canEditAllParticipants?: boolean;
  onEditParticipantClick?: (participant: Participant) => void;
  onChangeSchoolClick: (participant: Participant) => void;
  visibleTabs?: string[];
}

interface State {
  currentTabIndex: number;
  eventTaskIndex: number;
  eventDetails: any;
  isLoading: boolean;
  isEditPerformance: boolean;
  isEditDiscipline: boolean;
  isEditAttendance: boolean;
  isEditMatchReportActive: boolean;
  isEditEventDetailsModalOpen: boolean;
  isCreateEventJobModalOpen: boolean;
  isDeleteJobModalOpen: boolean;
  isErrorModalOpen: boolean;
  isVenueFormOpen: boolean;
  errorMessage: string;
  eventTasks: any[];
  reports: Report[];
  consents: Report[];
  point: Point;
  individualPerformance: SchoolEventIndividualPerformance[];
  individualDiscipline: SchoolEventIndividualDiscipline[];
  attendancePlayers: SchoolEventAttendance[];
  event: SchoolEvent;
  photos: Photo[];
  videos: Video[];
  isUpdateAccessPreset: boolean;
  matchReport: string;
  matchReportStatus: 'draft' | 'published';
  sports: Sport[];
  playersForSummary: SchoolEventPlayerSummary[];
  teamsForSummary: SchoolEventTeamSummary[];
  isEditPositions: boolean;
  isEditAllAttendance: boolean;
  activeTeamIndex: number;

  eventAwards: AwardEvent[];
  isEventAwardsLoading: boolean;
  awardTypesById: Record<string, { name: string; picture?: string | null }>;

  isAwardEditOpen: boolean;
  awardEditError: string | null;
  awardFormDraft?: Partial<AwardEventFormValues>;
  awardEditing?: any;
  isAwardSubmitting: boolean;
  isAwardsModuleActive?: boolean;

  isAwardDeleteOpen: boolean;
  awardDeleting?: any;

  isGrantParticipantsOpen: boolean;
  selectedEventStudents: StudentLite[];
  isGrantAwardOpen: boolean;
  preselectedAwardType: AwardType | null;
  grantAwardStudents: StudentLite[] | null;
  isNoHouseWarningOpen: boolean;
  isPartialHouseWarningOpen: boolean;
  studentsWithoutHouse: StudentLite[];

  studentHouseByUserId?: Record<string, { id: string | null; name: string }>;
  isGrantParticipantsLoading?: boolean;

  studentDetailsByKey?: Record<
    string,
    {
      formId: string | null;
      formName: string;
      yearName: string;
      houseId: string | null;
      houseName: string;
    }
  >;
  extForms?: any[];
  extHouses?: any[];
  isAttendanceLogModalOpen: boolean;
}

type EventPlayerLite = {
  userId?: string;
  permissionId?: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
};

export class SchoolEventTabs extends Component<Props, State> {
  private loadRequestId = 0;
  photoFileInputRef: any;
  videoFileInputRef: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      currentTabIndex: props.tabIndex || 0,
      eventTaskIndex: 0,
      eventDetails: undefined,
      isLoading: true,
      isEditPerformance: false,
      isEditDiscipline: false,
      isEditAttendance: false,
      isEditMatchReportActive: true,
      isEditEventDetailsModalOpen: false,
      isCreateEventJobModalOpen: false,
      isDeleteJobModalOpen: false,
      isVenueFormOpen: false,
      eventTasks: [],
      reports: [],
      consents: [],
      point: undefined,
      individualPerformance: [],
      individualDiscipline: [],
      attendancePlayers: [],
      isErrorModalOpen: false,
      errorMessage: '',
      event: props.eventInitial,
      photos: [],
      videos: [],
      isUpdateAccessPreset: false,
      matchReport: '',
      matchReportStatus: 'draft',
      sports: [],
      playersForSummary: [],
      teamsForSummary: [],
      isEditPositions: false,
      isEditAllAttendance: false,
      activeTeamIndex: 0,

      eventAwards: [],
      isEventAwardsLoading: false,
      awardTypesById: {},

      isAwardEditOpen: false,
      awardEditError: null,
      awardFormDraft: undefined,
      awardEditing: undefined,
      isAwardSubmitting: false,

      isAwardDeleteOpen: false,
      awardDeleting: undefined,

      isGrantParticipantsOpen: false,
      selectedEventStudents: [],
      isGrantAwardOpen: false,
      preselectedAwardType: null,
      grantAwardStudents: null,
      isNoHouseWarningOpen: false,
      isPartialHouseWarningOpen: false,
      studentsWithoutHouse: [],
      extForms: undefined,
      extHouses: undefined,
      isAttendanceLogModalOpen: false
    };

    this.photoFileInputRef = React.createRef();
    this.videoFileInputRef = React.createRef();
  }

  private showRequestError = (error: any, fallbackMessage: string) => {
    const errorText =
      propz.get(error, ['response', 'data', 'details', 'text'], '') ||
      propz.get(error, ['response', 'data', 'message'], '') ||
      propz.get(error, ['message'], '') ||
      fallbackMessage;

    this.setState({
      isLoading: false,
      isUpdateAccessPreset: false,
      errorMessage: errorText,
      isErrorModalOpen: true
    });
  };

  getVisibleTabs = (event: SchoolEvent, isExistReports: boolean, isExistConsents: boolean): string[] => {
    const availabilityWorkflow = propz.get(
      this.props.user,
      ['activeSchool', 'settings', 'availabilityWorkflow'],
      'SELF_SERVICE'
    );
    // Manual and automatic workflows need an empty Availability reports tab:
    // that is where staff send the first request. The legacy tab helper hides
    // it when no responses exist, which otherwise makes the workflow impossible
    // to start.
    const shouldShowAvailability = isExistReports || availabilityWorkflow !== 'SELF_SERVICE';
    const tabs = getEventViewTabs(event, shouldShowAvailability, isExistConsents).filter(tab => tab !== TABS.FEED);
    if (!tabs.includes(TABS.COMMUNICATIONS)) tabs.push(TABS.COMMUNICATIONS);
    const { visibleTabs } = this.props;
    const visible = visibleTabs ? tabs.filter(tab => visibleTabs.includes(tab)) : tabs;
    if (
      (!this.props.user.activeSchool || (this.props.user.activeSchool as any).eventCommunicationsAvailable !== false) &&
      visible.includes(TABS.COMMUNICATIONS) &&
      !visible.includes(TABS.COMMUNICATION_NOTIFICATIONS)
    ) {
      visible.push(TABS.COMMUNICATION_NOTIFICATIONS);
    }
    return visible;
  };

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setItems();

    const tabs = this.getVisibleTabs(this.state.event, false, false);
    if (tabs[this.state.currentTabIndex] === TABS.AWARDS) {
      this.loadEventAwards();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.eventInitial !== this.props.eventInitial) {
      if (prevProps.dataOnlyRefreshVersion !== this.props.dataOnlyRefreshVersion) {
        this.setState({ event: this.props.eventInitial, isLoading: false });
        return;
      }
      this.setState({ event: this.props.eventInitial, isLoading: true }, () => {
        this.setItems();
        const { reports, consents, currentTabIndex, event } = this.state;
        const tabs = this.getVisibleTabs(event, reports.length > 0, consents.length > 0);
        if (tabs[currentTabIndex] === TABS.AWARDS) {
          this.loadEventAwards();
        }
      });
    }
  }

  componentWillUnmount() {
    this.loadRequestId += 1;
  }

  setItems() {
    const requestId = ++this.loadRequestId;
    const { currentTabIndex, event, reports, consents } = this.state;
    const filter = { limit: DEFAULT_LIMIT, order: 'name ASC', skip: DEFAULT_SKIP };
    const isExistReports = reports.length > 0;
    const isExistConsents = consents.length > 0;
    const { user } = this.props;
    const tabs = this.getVisibleTabs(event, isExistReports, isExistConsents);
    const currentTab = tabs[currentTabIndex];
    const { id } = event;
    const isCurrentTabDetails = currentTab === TABS.DETAILS;
    const isCurrentTabDetailsOrKit = currentTab === TABS.DETAILS || currentTab === TABS.KIT;

    const sportsPromise = getSchoolSports(user, filter);

    // The legacy messages endpoint revives and hydrates up to 3,000 records and
    // made the whole event wait for data that the participants tab only needs
    // in compact form. Use only each pupil's current lean workflow revision;
    // the complete immutable history remains lazy-loaded by its dedicated tab.
    const getAvailabilityReportsPromise = currentTab === TABS.AVAILABILITY_REPORTS
      ? getAvailabilityReports(user, event.id)
      : getEventAvailabilityWorkflow(user, event.id).then(state => state.items
          .filter(item => Boolean(item.current))
          .map(item => ({
            ...item.current,
            playerDetails: item.current.playerDetails || {
              userId: item.player.userId,
              permissionId: item.player.permissionId
            },
            playerDetailsData: {
              ...(item.current.playerDetailsData || {}),
              firstName: item.player.firstName,
              lastName: item.player.lastName
            }
          } as Report)));
    const getParentalConsentPromise = getParentalConsent(user, event.id);
    const eventPlayerIds = getPlayers(user.activeSchoolId, event)
      .map(player => player.userId)
      .filter(Boolean);
    const eventStudentsPromise = eventPlayerIds.length
      ? getAllSchoolStudents(user, { id: { $in: eventPlayerIds } })
      : BPromise.resolve([]);
    const getSchoolEventDetailsPromise = isCurrentTabDetailsOrKit ? getSchoolEventDetails(user, id) : [];
    const promises = [
      getAvailabilityReportsPromise,
      getParentalConsentPromise,
      getSchoolEventDetailsPromise,
      sportsPromise,
      eventStudentsPromise
    ];

    const isParticipantsTab = currentTab === TABS.PARTICIPANTS || currentTab === TABS.PLAYERS;
    if (isParticipantsTab) {
      // Make the roster interactive as soon as its own availability state is
      // ready. Consent hydration, the sports catalogue and student enrichment
      // are useful elsewhere, but must not hold the participants tab hostage.
      getAvailabilityReportsPromise
        .then(nextReports => {
          if (requestId !== this.loadRequestId) return;
          this.setState({ reports: nextReports, isLoading: false });
        })
        .catch(error => {
          if (requestId !== this.loadRequestId) return;
          this.showRequestError(error, 'Availability information could not be loaded. Please try again.');
        });

      BPromise.all([getParentalConsentPromise, sportsPromise, eventStudentsPromise])
        .then(([nextConsents, nextSports, eventStudents]) => {
          if (requestId !== this.loadRequestId) return;
          this.setState({
            consents: this.getMessagesSortedAsWellAsTeam(nextConsents, eventStudents),
            sports: nextSports
          });
        })
        .catch(error => console.error('Unable to preload secondary event data', error));
      return;
    }

    BPromise.all(promises)
      .then(([reports, consents, details, sports, eventStudents]) => {
        if (requestId !== this.loadRequestId) return;
        const allConsents = this.getMessagesSortedAsWellAsTeam(consents, eventStudents);
        this.setState({
          eventDetails: details,
          reports: reports,
          consents: allConsents,
          sports: sports,
          isLoading: false
        });
      })
      .catch(error => {
        if (requestId !== this.loadRequestId) return;
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  }

  getMessagesSortedAsWellAsTeam(consents, eventStudents = []) {
    const { event } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;

    const teamPlayers = getPlayers(activeSchoolId, event);
    const msgPlayers = consents.map(msg => msg.playerDetails);
    //sorts an array of messages in the same order as the players in the team
    let messagesSortedAsWellAsTeam = [];

    teamPlayers.forEach(teamPlayer => {
      const student = eventStudents.find(
        item =>
          (item.id === teamPlayer.userId || item.userId === teamPlayer.userId) &&
          (!item.permissionId || item.permissionId === teamPlayer.permissionId)
      );
      const playerDetailsData = student ? { ...teamPlayer, ...student } : teamPlayer;
      const index = msgPlayers.findIndex(
        msgPlayer => teamPlayer.userId === msgPlayer.userId && teamPlayer.permissionId === msgPlayer.permissionId
      );

      if (index === -1) {
        //not notified players
        messagesSortedAsWellAsTeam.push({
          playerDetails: {
            userId: teamPlayer.userId,
            permissionId: teamPlayer.permissionId
          },
          playerDetailsData,
          schoolId: activeSchoolId,
          invitationStatus: 'NOT_SEND'
        });
      } else {
        messagesSortedAsWellAsTeam.push({
          ...consents[index],
          playerDetailsData: { ...playerDetailsData, ...consents[index].playerDetailsData }
        });
      }
    });

    return messagesSortedAsWellAsTeam;
  }

  getInitAttendancePlayers = attendancePlayers => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { event } = this.state;
    const allTeamPlayers = getEventPlayers(event, activeSchoolId);
    const nextAttendancePlayers = allTeamPlayers.map(player => {
      const attendanceIndex = attendancePlayers.findIndex(
        attendance =>
          String(attendance.userId) === String(player.userId) &&
          String(attendance.permissionId) === String(player.permissionId)
      );
      if (attendanceIndex === -1) {
        return {
          userId: player.userId,
          permissionId: player.permissionId
        };
      } else {
        const allAttendancePlayers = attendancePlayers.map(attendance => ({ ...attendance }));
        return allAttendancePlayers[attendanceIndex];
      }
    });
    return nextAttendancePlayers;
  };

  onOpenAttendanceLog = () => {
    this.setState({ isAttendanceLogModalOpen: true });
  };

  onCloseAttendanceLog = () => {
    this.setState({ isAttendanceLogModalOpen: false });
  };

  private loadEventAwards = async () => {
    const { user } = this.props;
    const { event } = this.state;
    if (!event?.id) return;

    this.setState({ isEventAwardsLoading: true });
    try {
      const items = await getEventAwardEvents(user, event.id, { order: 'awardedAt DESC' });

      await this.ensureAwardTypesLoaded();

      this.setState({ eventAwards: items, isEventAwardsLoading: false });
    } catch (e) {
      console.error('Failed to load event awards', e);
      this.setState({ isEventAwardsLoading: false });
      this.showRequestError(e, 'Awards could not be loaded. Please try again.');
    }
  };

  private getSchoolLookups() {
    const forms = new Map<string, any>();
    const houses = new Map<string, any>();
    const sch: any = this.props.user?.activeSchool;

    const extForms = this.state.extForms || [];
    const extHouses = this.state.extHouses || [];

    const allForms = Array.isArray(sch?.forms) && sch.forms.length ? sch.forms : extForms;
    const allHouses = Array.isArray(sch?.houses) && sch.houses.length ? sch.houses : extHouses;

    allForms.forEach((f: any) => forms.set(String(f.id), f));
    allHouses.forEach((h: any) => houses.set(String(h.id), h));
    return { forms, houses };
  }

  private loadSchoolLookups = async () => {
    const { user } = this.props;
    const [houses, forms] = await Promise.all([getAllHouses(user), getAllForms(user)]);
    this.setState({ extHouses: houses, extForms: forms });
  };

  private mapPlayersToStudentLite = (): Array<
    StudentLite & { gender?: string; formName?: string; yearName?: string; houseName?: string }
  > => {
    const { event, studentDetailsByKey } = this.state;
    const { user } = this.props;

    const players = (getEventPlayers(event, user.activeSchoolId) as any[]) || [];

    return players.map((p: any) => {
      const key = `${String(p?.userId || '')}|${String(p?.permissionId || '')}`;
      const resolved = studentDetailsByKey?.[key];

      const houseId = resolved?.houseId ?? p?.houseId ?? p?.house?.id ?? null;
      const houseName = resolved?.houseName || p?.house?.name || '';
      const formName = resolved?.formName || p?.form?.name || '';
      const yearName = resolved?.yearName || (p?.form?.ageGroup ?? p?.form?.year ?? '') || '';

      return {
        id: p.userId,
        permissionId: p.permissionId,
        firstName: p.firstName,
        lastName: p.lastName,
        houseId,
        house: houseId ? { id: houseId } : null,
        houseName,
        gender: p?.gender,
        formName,
        yearName
      };
    });
  };

  private getHouseId = (s: any): string | null => {
    const key = `${String(s?.id || '')}|${String(s?.permissionId || '')}`;
    const resolved = this.state.studentDetailsByKey?.[key];
    return resolved?.houseId ?? s?.houseId ?? s?.house?.id ?? null;
  };

  private toggleSelectAllParticipants = (all: StudentLite[]) => {
    const { selectedEventStudents } = this.state;
    if (selectedEventStudents.length === all.length) {
      this.setState({ selectedEventStudents: [] });
    } else {
      this.setState({ selectedEventStudents: all });
    }
  };

  private toggleSelectOneParticipant = (s: StudentLite) => {
    const { selectedEventStudents } = this.state;
    const exists = selectedEventStudents.some(x => x.id === s.id && x.permissionId === s.permissionId);
    this.setState({
      selectedEventStudents: exists
        ? selectedEventStudents.filter(x => !(x.id === s.id && x.permissionId === s.permissionId))
        : [...selectedEventStudents, s]
    });
  };

  private ensureHousePointsType = async (): Promise<AwardType> => {
    const { user } = this.props;
    const schoolPicRaw = user?.activeSchool?.pic as string | undefined;
    const picture = schoolPicRaw
      ? schoolPicRaw.startsWith('//')
        ? `${window.location.protocol}${schoolPicRaw}`
        : schoolPicRaw
      : undefined;

    const filter = {
      where: { name: 'House Points', isSystemHidden: true },
      limit: 1
    };

    const existing = await getSchoolAwardTypes(user, filter);
    if (existing && existing.length) return existing[0];

    const payload: any = {
      name: 'House Points',
      isSystemHidden: true,
      defaultHousePoints: 0
    };
    if (picture) payload.picture = picture;

    try {
      return await createAwardType(user, payload);
    } catch (err) {
      const e: any = err;
      const status = e?.response?.status;
      const text = e?.response?.data?.details?.text;

      if (status === 409 || text === 'duplicate error') {
        const retry = await getSchoolAwardTypes(user, filter);
        if (retry && retry.length) return retry[0];
      }

      throw err;
    }
  };

  private ensureHousePointsTypeAndOpenGrant = async (target: StudentLite[]) => {
    const isActive = await isModuleActiveFresh(this.props.user, 'AWARDS');
    if (!isActive) {
      this.setState({
        isAwardsModuleActive: false,
        isGrantAwardOpen: true,
        grantAwardStudents: target,
        preselectedAwardType: null
      });
      return;
    }

    const hpType = await this.ensureHousePointsType();

    this.setState({
      isAwardsModuleActive: true,
      preselectedAwardType: hpType,
      isGrantAwardOpen: true,
      grantAwardStudents: target
    });
  };

  private openGrantHousePointsFromEvent = () => {
    const { selectedEventStudents } = this.state;
    if (!selectedEventStudents.length) return;
    const withHouse = selectedEventStudents.filter(s => this.getHouseId(s));
    const noHouse = selectedEventStudents.filter(s => !this.getHouseId(s));

    if (!withHouse.length) {
      this.setState({ isNoHouseWarningOpen: true, studentsWithoutHouse: noHouse });
      return;
    }
    if (noHouse.length) {
      this.setState({ isPartialHouseWarningOpen: true, studentsWithoutHouse: noHouse });
      return;
    }
    this.ensureHousePointsTypeAndOpenGrant(withHouse).catch(e => {
      console.error(e);
      alert('Unable to open House Points grant right now.');
    });
  };

  private openGrantAwardFromEvent = async () => {
    const { selectedEventStudents } = this.state;
    if (!selectedEventStudents.length) return;
    try {
      const isActive = await isModuleActiveFresh(this.props.user, 'AWARDS');
      this.setState({
        isAwardsModuleActive: isActive,
        isGrantAwardOpen: true,
        preselectedAwardType: null,
        grantAwardStudents: selectedEventStudents
      });
    } catch (error) {
      this.showRequestError(error, 'The awards module status could not be checked. Please try again.');
    }
  };

  private closeNoHouseWarning = () => this.setState({ isNoHouseWarningOpen: false, studentsWithoutHouse: [] });
  private closePartialHouseWarning = () => this.setState({ isPartialHouseWarningOpen: false });
  private confirmGrantOnlyWithHouse = () => {
    const { selectedEventStudents, studentsWithoutHouse } = this.state;
    const blacklist = new Set(studentsWithoutHouse.map(s => `${s.id}|${s.permissionId}`));
    const withHouse = selectedEventStudents.filter(s => !blacklist.has(`${s.id}|${s.permissionId}`));
    this.setState({ isPartialHouseWarningOpen: false }, () => {
      this.ensureHousePointsTypeAndOpenGrant(withHouse).catch(e => {
        console.error(e);
        alert('Unable to open House Points grant right now.');
      });
    });
  };

  renderGrantParticipantsModal(): React.ReactNode {
    const { isGrantParticipantsOpen, selectedEventStudents, isGrantParticipantsLoading } = this.state;
    if (!isGrantParticipantsOpen) return null;

    const rows = this.mapPlayersToStudentLite();
    const allSelected = selectedEventStudents.length === rows.length && rows.length > 0;

    return (
      <SimpleModal
        isOpen={isGrantParticipantsOpen}
        title="Select participants to grant"
        onCloseClick={this.closeGrantParticipants}
        customClass="myGrantParticipantsModal"
      >
        {isGrantParticipantsLoading ? (
          <div className="py-4">
            <Loader />
          </div>
        ) : (
          <>
            <div className="mb-3 d-flex align-items-center gp-toolbar">
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={() => this.toggleSelectAllParticipants(rows)}
              >
                {allSelected ? 'Unselect all' : 'Select all'}
              </button>

              <div className="ml-auto d-flex align-items-center">
                <span className="text-muted small mr-3">
                  Selected {selectedEventStudents.length} / {rows.length}
                </span>
                <button
                  className="btn btn-sm btn-primary mr-2"
                  onClick={this.openGrantHousePointsFromEvent}
                  disabled={!selectedEventStudents.length}
                >
                  Grant House Points
                </button>
                <button
                  className="btn btn-sm btn-primary"
                  onClick={this.openGrantAwardFromEvent}
                  disabled={!selectedEventStudents.length}
                >
                  Grant Award
                </button>
              </div>
            </div>

            <div className="gp-table-wrap">
              <table className="table table-sm table-hover mb-0 gp-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Surname</th>
                    <th>Gender</th>
                    <th>Form</th>
                    <th>Year</th>
                    <th>House</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map(r => {
                    const checked = selectedEventStudents.some(s => s.id === r.id && s.permissionId === r.permissionId);
                    return (
                      <tr
                        key={`${r.id}|${r.permissionId}`}
                        className={`gp-row ${checked ? 'gp-selected' : ''}`}
                        onClick={() => this.toggleSelectOneParticipant(r)}
                        tabIndex={0}
                        role="button"
                        aria-pressed={checked}
                        onKeyDown={e => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            this.toggleSelectOneParticipant(r);
                          }
                        }}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => this.toggleSelectOneParticipant(r)}
                            onClick={e => e.stopPropagation()} // prevent double toggle
                            onKeyDown={e => e.stopPropagation()} // keep keyboard events on row
                          />
                        </td>
                        <td className="text-truncate" title={r.firstName}>
                          {r.firstName}
                        </td>
                        <td className="text-truncate" title={r.lastName}>
                          {r.lastName}
                        </td>
                        <td>{r.gender || '—'}</td>
                        <td className="text-truncate" title={r.formName}>
                          {r.formName || '—'}
                        </td>
                        <td>{r.yearName || '—'}</td>
                        <td className="text-truncate" title={r.houseName}>
                          {r.houseName || '—'}
                        </td>
                      </tr>
                    );
                  })}
                  {rows.length === 0 && (
                    <tr>
                      <td colSpan={7} className="text-muted text-center py-3">
                        No participants found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </SimpleModal>
    );
  }

  renderGrantAwardModal(): React.ReactNode {
    const { isGrantAwardOpen, grantAwardStudents, preselectedAwardType, event, isAwardsModuleActive } = this.state;
    const { user } = this.props;
    if (!isGrantAwardOpen || !grantAwardStudents || grantAwardStudents.length === 0) return null;

    if (isAwardsModuleActive === false) {
      return (
        <ModuleUpsellModal
          isOpen={isGrantAwardOpen}
          onClose={() =>
            this.setState({
              isGrantAwardOpen: false,
              preselectedAwardType: null,
              grantAwardStudents: null,
              isAwardsModuleActive: undefined
            })
          }
          module="AWARDS"
        />
      );
    }

    if (isAwardsModuleActive === undefined) return null;

    return (
      <GrantAwardModal
        isOpen={isGrantAwardOpen}
        onClose={res => {
          const granted = !!res?.granted;

          this.setState({
            isGrantAwardOpen: false,
            preselectedAwardType: null,
            grantAwardStudents: null,
            isAwardsModuleActive: undefined,
            ...(granted ? { isGrantParticipantsOpen: false, selectedEventStudents: [] } : null)
          });

          this.loadEventAwards();
        }}
        students={grantAwardStudents}
        user={user}
        preselectedType={preselectedAwardType}
        eventId={event?.id}
      />
    );
  }

  renderNoHouseWarning(): React.ReactNode {
    const { isNoHouseWarningOpen } = this.state;
    return (
      <SimpleModal
        isOpen={isNoHouseWarningOpen}
        title="Cannot grant house points"
        body="None of the selected students has a house assigned. Assign a house first, then try again."
        buttonText="OK"
        onButtonClick={this.closeNoHouseWarning}
        onCloseClick={this.closeNoHouseWarning}
      />
    );
  }

  renderPartialHouseWarning(): React.ReactNode {
    const { isPartialHouseWarningOpen, studentsWithoutHouse } = this.state;
    const MAX = 8;
    const visible = studentsWithoutHouse.slice(0, MAX);
    const extra = Math.max(0, studentsWithoutHouse.length - visible.length);
    return (
      <SimpleModal
        isOpen={isPartialHouseWarningOpen}
        title="Some students aren’t in a house"
        buttonText="Continue for students with a house"
        buttonCancelText="Go back"
        onButtonClick={this.confirmGrantOnlyWithHouse}
        onCloseClick={this.closePartialHouseWarning}
      >
        <div className="mb-2">
          <p className="mb-2">
            We’ll grant the award to all selected students, but
            <strong>
              {' '}
              {studentsWithoutHouse.length} student{studentsWithoutHouse.length === 1 ? '' : 's'} will receive 0 house
              points
            </strong>{' '}
            because they aren’t assigned to a house:
          </p>
          <ul className="list-group mb-2">
            {visible.map((s, i) => (
              <li key={`${s.id}|${s.permissionId}`} className="list-group-item py-1 d-flex align-items-center">
                <span className="badge badge-secondary mr-2" style={{ minWidth: 22 }}>
                  {i + 1}
                </span>
                <span className="text-truncate">{`${s.firstName} ${s.lastName}`}</span>
              </li>
            ))}
            {extra > 0 && <li className="list-group-item py-1 text-muted">+ {extra} more</li>}
          </ul>
          <small className="text-muted">Tip: assign houses so everyone can earn house points.</small>
        </div>
      </SimpleModal>
    );
  }

  openGrantParticipants = async () => {
    const { user } = this.props;
    const { event } = this.state;

    const players = (getEventPlayers(event, user.activeSchoolId) as any[]) || [];
    const ids = Array.from(
      new Set(
        players
          .map(p => p?.userId)
          .filter(Boolean)
          .map(String)
      )
    );
    this.setState({ isGrantParticipantsOpen: true, isGrantParticipantsLoading: true });

    try {
      const students: any[] = ids.length ? await getAllSchoolStudents(user, { id: { $in: ids } }) : [];

      let { forms, houses } = this.getSchoolLookups();
      if (forms.size === 0 || houses.size === 0) {
        await this.loadSchoolLookups();
        ({ forms, houses } = this.getSchoolLookups());
      }
      const studentById = new Map<string, any>(students.map(s => [String(s.id), s]));

      const studentDetailsByKey: Record<
        string,
        {
          formId: string | null;
          formName: string;
          yearName: string;
          houseId: string | null;
          houseName: string;
        }
      > = {};

      for (const p of players) {
        const uid = String(p?.userId || '');
        const pid = String(p?.permissionId || '');
        if (!uid) continue;

        const s = studentById.get(uid);
        const perms: any[] = Array.isArray(s?.permissions) ? s.permissions : [];
        const perm = perms.find(
          pp => String(pp?.id ?? pp?._id) === pid || (!pid && String(pp?.schoolId) === String(user.activeSchoolId))
        );

        let houseId: string | null = null;
        let houseName = '';
        let formId: string | null = null;
        let formName = '';
        let yearName = '';

        const det = perm?.details;
        if (det) {
          if (det.houseId) {
            houseId = String(det.houseId);
            houseName = houses.get(houseId)?.name || '';
          }
          if (det.formId) {
            formId = String(det.formId);
            const f = forms.get(formId);
            if (f) {
              formName = f?.name || '';
              yearName = f?.ageGroup ?? f?.year ?? '';
            }
          }
        }

        if (!houseName) {
          const sid = s?.houseId || s?.house?.id;
          if (sid && houses.has(String(sid))) {
            houseId = String(sid);
            houseName = houses.get(houseId)?.name || houseName;
          }
        }
        if (!houseName) {
          const sh = Array.isArray(s?.houses) ? s.houses[0] : null;
          const sid = sh?.id || sh?._id;
          if (sid && houses.has(String(sid))) {
            houseId = String(sid);
            houseName = houses.get(houseId)?.name || houseName;
          }
        }
        if (!houseName) {
          houseName = s?.studentHouseName || '';
        }
        if (!houseName) {
          houseName = p?.house?.name || '';
        }

        if (!formName || !yearName) {
          const sfid = s?.formId || s?.form?.id;
          if (sfid && forms.has(String(sfid))) {
            const f = forms.get(String(sfid));
            if (!formName) formName = f?.name || '';
            if (!yearName) yearName = f?.ageGroup ?? f?.year ?? '';
          }
        }
        if (!formName || !yearName) {
          const sf =
            Array.isArray(s?.forms) && s.forms.length
              ? pid
                ? s.forms.find((x: any) => String(x?.permissionId) === pid) || s.forms[0]
                : s.forms[0]
              : null;
          if (sf) {
            if (!formName) formName = sf?.name || '';
            if (!yearName) yearName = sf?.ageGroup ?? sf?.year ?? '';
          }
        }
        if (!formName) formName = p?.form?.name || '';
        if (!yearName) yearName = p?.form?.ageGroup ?? p?.form?.year ?? '';

        studentDetailsByKey[`${uid}|${pid}`] = { formId, formName, yearName, houseId, houseName };
      }

      this.setState({ studentDetailsByKey });
    } catch (e) {
      this.showRequestError(e, 'Participant details could not be loaded. Please try again.');
    } finally {
      this.setState({ isGrantParticipantsLoading: false });
    }
  };

  closeGrantParticipants = () => {
    this.setState({
      isGrantParticipantsOpen: false,
      selectedEventStudents: []
    });
  };

  onTabClick = (e, index: number) => {
    if (typeof e !== 'undefined') {
      e.preventDefault();
    }

    const { user } = this.props;
    const {
      isEditPerformance,
      isEditAttendance,
      event,
      reports,
      consents,
      isEditPositions,
      isEditDiscipline
    } = this.state;
    const { id, results } = event;
    const isExistReports = reports.length > 0;
    const isExistConsents = consents.length > 0;

    const tabs = this.getVisibleTabs(event, isExistReports, isExistConsents);
    const currentTab = tabs[index];

    if (isEditPerformance || isEditAttendance || isEditPositions || isEditDiscipline) {
      return;
    }

    const { individualPerformance, attendance, individualDiscipline } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    switch (currentTab) {
      case TABS.DETAILS: {
        this.setState({
          isLoading: true
        });
        getSchoolEventDetails(user, id)
          .then(details => {
            this.setState({
              currentTabIndex: index,
              eventDetails: details,
              isLoading: false
            });
          })
          .catch(error => {
            this.showRequestError(error, 'Event details could not be loaded. Please try again.');
          });
        break;
      }
      case TABS.JOBS: {
        this.setState({
          isLoading: true
        });
        getEventTasks(user, id)
          .then(eventTasks => {
            this.setState({
              currentTabIndex: index,
              eventTasks: eventTasks,
              isLoading: false
            });
          })
          .catch(error => {
            this.showRequestError(error, 'Event jobs could not be loaded. Please try again.');
          });
        break;
      }

      case TABS.POSITIONS:
        const playersForSummary = this.getPlayersForSummary(event);
        const teamsForSummary = this.getTeamsForSummary();
        this.setState({
          currentTabIndex: index,
          playersForSummary: playersForSummary,
          teamsForSummary: teamsForSummary
        });
        break;

      case TABS.PARTICIPANTS:
      case TABS.PLAYERS:
        this.setState({
          currentTabIndex: index,
          playersForSummary: this.getPlayersForSummary(event),
          teamsForSummary: this.getTeamsForSummary()
        });
        break;

      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE: {
        this.setState({
          currentTabIndex: index,
          individualPerformance: individualPerformance
        });
        break;
      }

      case TABS.DISCIPLINE: {
        this.setState({
          currentTabIndex: index,
          individualDiscipline: individualDiscipline
        });
        break;
      }

      case TABS.ATTENDANCE: {
        this.setState({
          currentTabIndex: index,
          attendancePlayers: attendancePlayers
        });
        break;
      }

      case TABS.AWARDS: {
        this.setState({ currentTabIndex: index }, this.loadEventAwards);
        break;
      }

      case TABS.GALLERY: {
        this.setState({
          isLoading: true
        });
        const promises = [getAllEventPhotos(user, id), getAllEventVideos(user, id)];
        BPromise.all(promises)
          .then(([photos, videos]) => {
            this.setState({
              isLoading: false,
              currentTabIndex: index,
              photos,
              videos
            });
          })
          .catch(error => {
            this.showRequestError(error, 'Event media could not be loaded. Please try again.');
          });
        break;
      }
      case TABS.AVAILABILITY_REPORTS: {
        this.setState({ isLoading: true });
        getAvailabilityReports(user, id)
          .then(availabilityReports => this.setState({
            currentTabIndex: index,
            reports: availabilityReports,
            isLoading: false
          }))
          .catch(error => this.showRequestError(error, 'Availability history could not be loaded. Please try again.'));
        break;
      }
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        this.setState({
          isLoading: true
        });
        getSchoolEventMatchReport(user, id)
          .then(matchReport => {
            const content = propz.get(matchReport, ['content'], '');
            const status = propz.get(matchReport, ['status'], content ? 'published' : 'draft');
            this.setState({
              currentTabIndex: index,
              matchReport: content,
              matchReportStatus: status,
              isLoading: false
            });
          })
          .catch(error => {
            this.showRequestError(error, 'The match report could not be loaded. Please try again.');
          });
        break;
      case TABS.KIT: {
        this.setState({
          isLoading: true
        });
        getSchoolEventDetails(user, id)
          .then(details => {
            this.setState({
              currentTabIndex: index,
              eventDetails: details,
              isLoading: false
            });
          })
          .catch(error => {
            this.showRequestError(error, 'Kit details could not be loaded. Please try again.');
          });
        break;
      }
      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  onClickGotIt = messageId => {
    const { user } = this.props;

    this.setState({
      isLoading: true
    });

    doGotItActionForEventMessage(user, messageId)
      .then(res => {
        this.setState({
          isLoading: false
        });
        this.setItems();
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onEditEventJobClick = (event, index) => {
    event.preventDefault();

    this.setState({
      isCreateEventJobModalOpen: true,
      eventTaskIndex: index
    });
  };

  deleteJobModalOpen = (event, index): void => {
    this.setState({
      isDeleteJobModalOpen: true,
      eventTaskIndex: index
    });
  };

  deleteJobModalClose = (): void => {
    this.setState({
      isDeleteJobModalOpen: false
    });
  };

  onDeleteJobClick = () => {
    const { user } = this.props;
    const { eventTasks, event, eventTaskIndex, reports, consents } = this.state;
    const { id } = event;
    const eventTaskId = eventTasks[eventTaskIndex].id;
    const isExistReports = reports.length > 0;
    const isExistConsents = consents.length > 0;

    this.setState({
      isDeleteJobModalOpen: false,
      isLoading: true
    });

    onDeleteJob(user, id, eventTaskId)
      .then(res => getEventTasks(user, id))
      .then(eventTasks => {
        const eventTab = this.getVisibleTabs(event, isExistReports, isExistConsents);
        const tabIndex = eventTab.indexOf(TABS.JOBS);
        this.setState({
          currentTabIndex: tabIndex,
          eventTasks: eventTasks,
          isLoading: false
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onChangeEventPerformanceClick = (value, player, performanceId) => {
    const { individualPerformance } = this.state;

    const performanceIndex = individualPerformance.findIndex(
      performance => performance.performanceId === performanceId && performance.userId === player.userId
    );

    let nextPerformance;

    if (performanceIndex === -1) {
      nextPerformance = [
        ...individualPerformance,
        {
          performanceId: performanceId,
          userId: player.userId,
          teamId: player.teamId,
          value: value,
          permissionId: player.permissionId
        }
      ];
    } else {
      nextPerformance = [...individualPerformance];
      nextPerformance[performanceIndex].value = value;
    }

    this.setState({
      individualPerformance: nextPerformance
    });
  };

  onChangeEventDisciplineClick = (value, player, disciplineId) => {
    const { individualDiscipline } = this.state;

    const disciplineIndex = individualDiscipline.findIndex(
      discipline => discipline.disciplineId === disciplineId && discipline.userId === player.userId
    );

    let nextDiscipline;

    if (disciplineIndex === -1) {
      nextDiscipline = [
        ...individualDiscipline,
        {
          disciplineId: disciplineId,
          userId: player.userId,
          teamId: player.teamId,
          value: Number(value),
          permissionId: player.permissionId
        }
      ];
    } else {
      nextDiscipline = [...individualDiscipline];
      nextDiscipline[disciplineIndex].value = Number(value);
    }

    this.setState({
      individualDiscipline: nextDiscipline
    });
  };

  onChangeMatchReport = matchReport => {
    this.setState({
      matchReport: matchReport
    });
  };

  onChangeEventAllAttendanceClick = (value: boolean): void => {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { attendancePlayers, event } = this.state;
    const allTeamPlayers = getEventPlayers(event, activeSchoolId);

    const nextAttendancePlayers = allTeamPlayers.map(player => {
      const attendanceIndex = attendancePlayers.findIndex(
        attendance =>
          String(attendance.userId) === String(player.userId) &&
          String(attendance.permissionId) === String(player.permissionId)
      );
      if (attendanceIndex === -1) {
        return {
          userId: player.userId,
          isAttendance: value,
          permissionId: player.permissionId
        };
      } else {
        const allAttendancePlayers = attendancePlayers.map(attendance => {
          return {
            ...attendance,
            isAttendance: value
          };
        });
        return allAttendancePlayers[attendanceIndex];
      }
    });
    this.setState({
      isEditAllAttendance: value,
      attendancePlayers: nextAttendancePlayers
    });
  };

  onChangeEventAttendanceClick = (
    value: boolean,
    player: SchoolEventIndividualData | SchoolEventTeamDataPlayer
  ): void => {
    const { attendancePlayers } = this.state;

    const attendanceIndex = attendancePlayers.findIndex(
      attendance =>
        String(attendance.userId) === String(player.userId) &&
        String(attendance.permissionId) === String(player.permissionId)
    );

    let nextAttendancePlayers;

    if (attendanceIndex === -1) {
      nextAttendancePlayers = [
        ...attendancePlayers,
        {
          userId: player.userId,
          isAttendance: value,
          permissionId: player.permissionId
        }
      ];
    } else {
      nextAttendancePlayers = attendancePlayers.map(attendance => {
        return String(attendance.userId) === String(player.userId) &&
          String(attendance.permissionId) === String(player.permissionId)
          ? {
              ...attendance,
              isAttendance: value
            }
          : { ...attendance };
      });
    }

    const isOneAttendancePresent = nextAttendancePlayers.every(player => {
      return propz.get(player, ['isAttendance'], true);
    });

    this.setState({
      isEditAllAttendance: isOneAttendancePresent,
      attendancePlayers: nextAttendancePlayers
    });
  };

  onChangeSchoolPhotoInfoClick = (photoId, data) => {
    const { user, eventInitial } = this.props;
    const { photos } = this.state;
    const { id } = eventInitial;

    this.setState({
      isUpdateAccessPreset: true
    });

    updateEventPhoto(user, id, photoId, data)
      .then(photoNext => {
        const photosNext = photos.map(photo => (photoId === photo.id ? photoNext : photo));
        this.setState({
          photos: photosNext,
          isUpdateAccessPreset: false
        });
      })
      .catch(error => {
        this.showRequestError(error, 'Photo details could not be updated. Please try again.');
      });
  };

  getContentTabs(): React.ReactNode {
    const {
      user,
      history,
      onRemoveParticipantClick,
      onChangeSchoolClick,
      onEditParticipantClick,
      participants,
      eventInitial,
      canRemoveParticipants = true,
      canEditAllParticipants = false
    } = this.props;
    const {
      currentTabIndex,
      eventDetails,
      isEditPerformance,
      isEditAttendance,
      isEditMatchReportActive,
      eventTasks,
      attendancePlayers,
      individualPerformance,
      matchReport,
      matchReportStatus,
      event,
      photos,
      videos,
      isUpdateAccessPreset,
      reports,
      consents,
      sports,
      activeTeamIndex,
      playersForSummary,
      teamsForSummary,
      isEditPositions,
      isEditAllAttendance,
      individualDiscipline,
      isEditDiscipline
    } = this.state;

    const { activeSchoolId } = user;
    const isExistReports = reports.length > 0;
    const isExistConsents = consents.length > 0;

    const tabs = this.getVisibleTabs(event, isExistReports, isExistConsents);
    const currentTab = tabs[currentTabIndex];

    const allTeamPlayers = getEventPlayers(event, activeSchoolId);

    const currentSport = sports.find(sport => sport.id === event.sportId);

    switch (currentTab) {
      case TABS.COMMUNICATIONS:
        return <EventCommunications user={user} eventId={event.id} panel="CHATS" />;
      case TABS.COMMUNICATION_NOTIFICATIONS:
        return <EventCommunications user={user} eventId={event.id} panel="SETTINGS" />;
      case TABS.DETAILS:
        return (
          <SchoolEventDetailsSummary
            schoolEvent={eventInitial}
            eventsDetails={eventDetails}
            user={user}
            onEditDetails={this.editEventDetailsModalOpen}
          />
        );
      case TABS.POSITIONS:
        return (
          <SchoolEventPlayersSummary
            schoolEvent={event}
            sport={currentSport}
            players={playersForSummary}
            teams={teamsForSummary}
            activeTeamIndex={activeTeamIndex}
            isEditPositions={isEditPositions}
            onChangeTeam={this.onChangeTeam}
            onChangePositionPlayer={this.onChangePositionPlayer}
            onChangeIsCaptainPlayer={this.onChangeIsCaptainPlayer}
            onChangeIsViceCaptainPlayer={this.onChangeIsViceCaptainPlayer}
            onChangeIsSubPlayer={this.onChangeIsSubPlayer}
          />
        );
      case TABS.JOBS:
        return (
          <SchoolEventJobsSummary
            eventTasks={eventTasks}
            onEditEventJobClick={this.onEditEventJobClick}
            onDeleteJobClick={this.deleteJobModalOpen}
          />
        );
      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE:
        return (
          <SchoolEventPerformanceSummary
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            onEditEventPerformanceClick={this.onChangeEventPerformanceClick}
            onEditPerformanceClick={this.onEditEventPerformanceClick}
            onSavePerformanceClick={this.onSaveEventPerformanceClick}
            individualPerformance={individualPerformance}
            isEditPerformance={isEditPerformance}
          />
        );
      case TABS.DISCIPLINE:
        return (
          <SchoolEventDisciplineSummary
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            onEditEventDisciplineClick={this.onChangeEventDisciplineClick}
            onEditDisciplineClick={this.onEditEventDisciplineClick}
            onSaveDisciplineClick={this.onSaveEventDisciplineClick}
            individualDiscipline={individualDiscipline}
            isEditDiscipline={isEditDiscipline}
          />
        );
      case TABS.ATTENDANCE:
        return (
          <SchoolEventAttendanceSummary
            user={user}
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            onChangeEventAttendanceClick={this.onChangeEventAttendanceClick}
            onChangeEventAllAttendanceClick={this.onChangeEventAllAttendanceClick}
            onChangeEventAttendanceComment={this.onChangeEventAttendanceComment}
            onEditAttendanceClick={this.onEditEventAttendanceClick}
            onCancelAttendanceClick={this.onCancelEventAttendanceClick}
            onSaveAttendanceClick={this.onSaveEventAttendanceClick}
            onOpenAttendanceLog={
              user.activeRole === 'ADMIN' || user.activeRole === 'MANAGER' ? this.onOpenAttendanceLog : undefined
            }
            attendancePlayers={attendancePlayers}
            isEditAttendance={isEditAttendance}
            isEditAllAttendance={isEditAllAttendance}
          />
        );
      case TABS.AWARDS: {
        const { eventAwards, isEventAwardsLoading, awardTypesById, event } = this.state;
        const { user } = this.props;

        const allTeamPlayers = (getEventPlayers(event, user.activeSchoolId) as EventPlayerLite[]) || [];

        if (isEventAwardsLoading) return <Loader />;

        return (
          <SchoolEventAwardsSummary
            awards={eventAwards}
            awardTypesById={awardTypesById}
            players={allTeamPlayers}
            onGrantAwardsClick={this.openGrantParticipants}
            onEditAwardClick={this.onAwardEditClick}
            onDeleteAwardClick={this.onAwardDeleteOpen}
          />
        );
      }
      case TABS.PARTICIPANTS:
      case TABS.PLAYERS:
        const playersForTeamsView = playersForSummary.length > 0 ? playersForSummary : this.getPlayersForSummary(event);
        return (
          <SchoolEventTeamsTab
            onRemoveParticipantClick={onRemoveParticipantClick}
            canRemoveParticipants={canRemoveParticipants}
            canEditAllParticipants={canEditAllParticipants}
            onEditParticipantClick={onEditParticipantClick}
            onChangeSchoolClick={onChangeSchoolClick}
            history={history}
            user={user}
            participants={participants}
            eventInitial={event}
            playersForSummary={playersForTeamsView}
            availabilityReports={this.state.reports}
            onChangeIsCaptainPlayer={this.onChangeIsCaptainPlayer}
            onChangeIsViceCaptainPlayer={this.onChangeIsViceCaptainPlayer}
            onChangeIsSubPlayer={this.onChangeIsSubPlayer}
          />
        );
      case TABS.GALLERY:
        return (
          <div className="eEventMedia">
            <div className="eEventMediaHeader">
              <div>
                <h2 className="eEventMediaHeader__title">Media</h2>
                <div className="eEventMediaHeader__subtitle">Photos and videos attached to this event.</div>
              </div>
              <div className="eEventMediaHeader__actions">
                <Button
                  onClick={this.onAddPhotoClick}
                  text={[<FontAwesomeIcon key="media_add_photo_icon" icon={faImage} />, 'Add photo']}
                  customClass="sit-btn sit-btn--secondary sit-btn--sm"
                />
                <Button
                  onClick={this.onAddVideoClick}
                  text={[<FontAwesomeIcon key="media_add_video_icon" icon={faVideo} />, 'Add video']}
                  customClass="sit-btn sit-btn--primary sit-btn--sm"
                />
              </div>
            </div>

            <div className="eEventMediaStats">
              <div className="eEventMediaStat eEventMediaStat--photos">
                <span className="eEventMediaStat__dot" />
                <span className="eEventMediaStat__label">Photos</span>
                <span className="eEventMediaStat__value">{photos.length}</span>
              </div>
              <div className="eEventMediaStat eEventMediaStat--videos">
                <span className="eEventMediaStat__dot" />
                <span className="eEventMediaStat__label">Videos</span>
                <span className="eEventMediaStat__value">{videos.length}</span>
              </div>
              <div className="eEventMediaStat eEventMediaStat--total">
                <span className="eEventMediaStat__dot" />
                <span className="eEventMediaStat__label">Total files</span>
                <span className="eEventMediaStat__value">{photos.length + videos.length}</span>
              </div>
            </div>

            <EventGallery
              onDeletePhotoClick={this.onDeletePhotoClick}
              user={user}
              eventInitial={event}
              photos={photos}
              onAccessPresetClick={this.onAccessPresetPhotoClick}
              isUpdateAccessPreset={isUpdateAccessPreset}
              onChangeSchoolPhotoInfoClick={this.onChangeSchoolPhotoInfoClick}
            />
            <EventVideos
              onDeleteVideoClick={this.onDeleteVideoClick}
              user={user}
              eventInitial={event}
              videos={videos}
              onAccessPresetClick={this.onAccessPresetVideoClick}
              isUpdateAccessPreset={isUpdateAccessPreset}
            />
          </div>
        );
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        return (
          <SchoolEventMatchReportSummary
            user={user}
            isEditMatchReportActive={isEditMatchReportActive}
            schoolEvent={event}
            matchReport={matchReport}
            matchReportStatus={matchReportStatus}
            onChangeMatchReport={this.onChangeMatchReport}
            onEditMatchReportClick={this.onEditEventMatchReportClick}
            onSaveMatchReportClick={this.onSaveEventMatchReportClick}
            onSaveMatchReportContent={this.onSaveEventMatchReportContent}
          />
        );
      case TABS.AVAILABILITY_REPORTS:
        return (
          <SchoolEventAvailabilityReportsSummary
            reports={reports}
            user={user}
            schoolEvent={event}
            onClickGotIt={this.onClickGotIt}
            onViewMapClick={this.onViewMapClick}
          />
        );
      case TABS.PARENTAL_CONSENT:
        return (
          <SchoolParentalConsentSummary
            onConsentUpdated={updated => this.setState(prev => ({
              consents: prev.consents.map(consent => consent.id === updated.id ? {
                ...consent, ...updated,
                playerDetailsData: { ...consent.playerDetailsData, ...updated.playerDetailsData }
              } : consent)
            }))}
            consents={consents}
            schoolEvent={event}
            user={user}
            onViewMapClick={this.onViewMapClick}
            showEditedPill
          />
        );
      case TABS.KIT:
        return <SchoolEventKitSummary user={user} event={event} eventsDetails={eventDetails} />;
      case TABS.FEED: {
        const isUnionContext = propz.get(user, ['activeSchool', 'kind']) === KIND.SCHOOL_UNION;
        return (
          <div className="eventFeedDisabled">
            <div className="eventFeedDisabled__icon">Feed</div>
            <h2>Feed is not enabled</h2>
            <p>
              {isUnionContext
                ? 'The event feed is not enabled. Contact a union administrator if you need this feature.'
                : 'Your school has not enabled the event feed. Contact a school administrator if you need this feature.'}
            </p>
          </div>
        );
      }
      default:
        return <EmptyComponent />;
    }
  }

  onAccessPresetPhotoClick = (photoId: string, accessPreset: ACCESS_PRESET_TYPE) => {
    const { user } = this.props;
    const { event, photos } = this.state;
    const { id } = event;

    this.setState({
      isUpdateAccessPreset: true
    });

    const dataToUpdate = {
      accessPreset
    };

    updateEventPhoto(user, id, photoId, dataToUpdate)
      .then(photoNext => {
        const photosNext = photos.map(photo => (photoId === photo.id ? photoNext : photo));
        this.setState({
          photos: photosNext,
          isUpdateAccessPreset: false
        });
      })
      .catch(error => {
        this.showRequestError(error, 'Photo access could not be updated. Please try again.');
      });
  };

  onAccessPresetVideoClick = (videoId: string, accessPreset: ACCESS_PRESET_TYPE) => {
    const { user } = this.props;
    const { event, videos } = this.state;
    const { id } = event;

    this.setState({
      isUpdateAccessPreset: true
    });

    const dataToUpdate = {
      accessPreset
    };

    updateEventVideo(user, id, videoId, dataToUpdate)
      .then(videoNext => {
        const videosNext = videos.map(video => (videoId === video.id ? videoNext : video));
        this.setState({
          videos: videosNext,
          isUpdateAccessPreset: false
        });
      })
      .catch(error => {
        this.showRequestError(error, 'Video access could not be updated. Please try again.');
      });
  };

  editEventDetailsModalOpen = () => {
    this.setState({
      isEditEventDetailsModalOpen: true
    });
  };

  onAddEventJobClick = event => {
    event.preventDefault();

    this.setState({
      isCreateEventJobModalOpen: true,
      eventTaskIndex: -1
    });
  };

  onEditEventPerformanceClick = () => {
    this.setState({
      isEditPerformance: true
    });
  };

  onSaveEventPerformanceClick = () => {
    const { individualPerformance, event } = this.state;
    const { user } = this.props;
    const { id } = event;

    this.setState({
      isLoading: true
    });

    const items = individualPerformance.map(({ userId, permissionId, teamId, performanceId, value, description }) => ({
      userId,
      permissionId,
      teamId,
      performanceId,
      value,
      description
    }));

    const savePromise = items.length ? batchEventPerformance(user, id, { items }) : Promise.resolve();
    savePromise
      .then(res => {
        return getSchoolEvent(user, id);
      })
      .then(event => {
        this.setState({
          isLoading: false,
          isEditPerformance: false,
          individualPerformance: event.results.individualPerformance,
          event: event
        });
      })
      .catch(error => {
        this.showRequestError(error, 'Performance could not be saved. Please try again.');
      });
  };

  onEditEventDisciplineClick = () => {
    this.setState({
      isEditDiscipline: true
    });
  };

  onSaveEventDisciplineClick = () => {
    const { individualDiscipline, event } = this.state;
    const { user } = this.props;
    const { id } = event;

    this.setState({
      isLoading: true
    });

    const items = individualDiscipline.map(({ userId, permissionId, teamId, disciplineId, value, description }) => ({
      userId,
      permissionId,
      teamId,
      disciplineId,
      value,
      description
    }));

    const savePromise = items.length ? batchEventDiscipline(user, id, { items }) : Promise.resolve();
    savePromise
      .then(res => {
        return getSchoolEvent(user, id);
      })
      .then(event => {
        this.setState({
          isLoading: false,
          isEditDiscipline: false,
          individualDiscipline: event.results.individualDiscipline,
          event: event
        });
      })
      .catch(error => {
        this.showRequestError(error, 'Discipline could not be saved. Please try again.');
      });
  };

  onEditEventMatchReportClick = () => {
    this.setState({
      isEditMatchReportActive: false
    });
  };

  onSaveEventMatchReportClick = () => {
    const { user } = this.props;
    const { event, matchReport, matchReportStatus } = this.state;
    const { id } = event;

    this.setState({
      isLoading: true,
      isEditMatchReportActive: true
    });

    const content = {
      content: matchReport,
      status: matchReportStatus
    };

    updateSchoolEventMatchReport(user, id, content)
      .then(matchReport => {
        const content = propz.get(matchReport, ['content'], '');
        const status = propz.get(matchReport, ['status'], content ? 'published' : 'draft');

        this.setState({
          isLoading: false,
          matchReport: content,
          matchReportStatus: status
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onSaveEventMatchReportContent = (matchReportContent: string, status: 'draft' | 'published') => {
    const { user } = this.props;
    const { event } = this.state;
    const { id } = event;

    this.setState({
      isLoading: true,
      isEditMatchReportActive: true,
      matchReport: matchReportContent,
      matchReportStatus: status
    });

    updateSchoolEventMatchReport(user, id, { content: matchReportContent, status })
      .then(matchReport => {
        const content = propz.get(matchReport, ['content'], '');
        const status = propz.get(matchReport, ['status'], content ? 'published' : 'draft');

        this.setState({
          isLoading: false,
          matchReport: content,
          matchReportStatus: status
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onEditEventAttendanceClick = () => {
    const { event } = this.state;
    const { results } = event;
    const { attendance } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    const allAttendancePlayers = this.getInitAttendancePlayers(attendancePlayers);

    const isOneAttendancePresent = allAttendancePlayers.every(player => {
      return propz.get(player, ['isAttendance'], false);
    });

    this.setState({
      attendancePlayers: allAttendancePlayers,
      isEditAllAttendance: isOneAttendancePresent,
      isEditAttendance: true
    });
  };

  onCancelEventAttendanceClick = () => {
    const { event } = this.state;
    const attendance = event.results.attendance;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    this.setState({
      attendancePlayers: attendancePlayers,
      isEditAttendance: false
      // isEditAllAttendance: true
    });
  };

  onSaveEventAttendanceClick = () => {
    const { attendancePlayers, event } = this.state;
    const { user } = this.props;
    const { id } = event;

    if (attendancePlayers.some(attendance => typeof attendance.isAttendance !== 'boolean')) {
      return;
    }

    this.setState({ isLoading: true });

    const items = attendancePlayers.map(attendance => ({
      userId: attendance.userId,
      permissionId: attendance.permissionId,
      isAttendance: attendance.isAttendance,
      publicComment: attendance.publicComment,
      internalComment: attendance.internalComment
    }));

    batchEventAttendance(user, id, { items })
      .then(() => getSchoolEvent(user, id))
      .then(event => {
        this.setState({
          isLoading: false,
          isEditAttendance: false,
          attendancePlayers: event.results.attendance,
          event: event
        });
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  onAwardEditClick = (award: any) => {
    this.setState({
      isAwardEditOpen: true,
      awardEditError: null,
      awardEditing: award,
      awardFormDraft: {
        awardedAt: award?.awardedAt ? Moment(award.awardedAt).format('YYYY-MM-DD') : Moment().format('YYYY-MM-DD'),
        points: award?.points ?? 0,
        reason: award?.reason || '',
        awardedByName: award?.awardedByName || ''
      }
    });
  };

  onAwardEditCancel = () => {
    this.setState({
      isAwardEditOpen: false,
      awardEditError: null,
      awardFormDraft: undefined,
      awardEditing: undefined,
      isAwardSubmitting: false
    });
  };

  onAwardEditSubmit = async (data: AwardEventFormValues) => {
    const { user } = this.props;
    const { awardEditing } = this.state;
    if (!awardEditing) return;

    this.setState({ isAwardSubmitting: true, awardEditError: null });
    try {
      await updateAwardEvent(user, data, awardEditing.id);

      await this.loadEventAwards();

      this.setState({
        isAwardEditOpen: false,
        awardEditError: null,
        awardFormDraft: undefined,
        awardEditing: undefined,
        isAwardSubmitting: false
      });
    } catch (err) {
      const e = err as any;

      const serverText = e?.response?.data?.details?.text || e?.response?.data?.error || e?.message || '';

      const isHouseValidation = /house/i.test(serverText) && /point/i.test(serverText);

      this.setState({
        awardEditError: isHouseValidation
          ? 'This student isn’t assigned to a house yet. To save, either set Points to 0 or assign them to a house.'
          : 'Something went wrong. Please try again.',
        isAwardSubmitting: false
      });
    }
  };

  onAwardDeleteOpen = (award: any) => {
    this.setState({ isAwardDeleteOpen: true, awardDeleting: award });
  };

  onAwardDeleteClose = () => {
    this.setState({ isAwardDeleteOpen: false, awardDeleting: undefined });
  };

  onAwardDeleteConfirm = async () => {
    const { user } = this.props;
    const { awardDeleting } = this.state;
    if (!awardDeleting) return;

    try {
      await deleteAwardEvent(user, awardDeleting.id);
      await this.loadEventAwards();
    } catch (error) {
      this.showRequestError(error, 'The award could not be deleted. Please try again.');
    } finally {
      this.setState({ isAwardDeleteOpen: false, awardDeleting: undefined });
    }
  };

  savePositions = (playersForSummary: SchoolEventPlayerSummary[], isShowLoader = false, isCloseEditMode = false) => {
    const { teamsForSummary, event } = this.state;
    const { user } = this.props;
    const { id } = event;
    const teamsForUpdate = teamsForSummary.length > 0 ? teamsForSummary : this.getTeamsForSummary();

    if (isShowLoader) {
      this.setState({
        isLoading: true
      });
    }

    const promise = isNonTeamSportEvent(event)
      ? updateSchoolEventIndividualsBatch(user, id, {
          add: [],
          remove: [],
          update: playersForSummary.map(player => {
            const { isCaptain, isViceCaptain, isSub, positionId, playerId } = player;
            return {
              isCaptain: isCaptain,
              isViceCaptain: isViceCaptain,
              sub: isSub,
              positionId: positionId !== '' ? positionId : null,
              id: playerId
            };
          })
        })
      : BPromise.all(
          teamsForUpdate.map(teamForSummary =>
            updateSchoolEventTeamPlayersBatch(user, id, teamForSummary.teamId, {
              add: [],
              remove: [],
              update: playersForSummary
                .filter(player => player.teamId === teamForSummary.teamId)
                .map(player => {
                  const { isCaptain, isViceCaptain, isSub, positionId, playerId } = player;
                  return {
                    isCaptain: isCaptain,
                    isViceCaptain: isViceCaptain,
                    sub: isSub,
                    positionId: positionId !== '' ? positionId : null,
                    id: playerId
                  };
                })
            })
          )
        );

    promise
      .then(res => {
        return getSchoolEvent(user, id);
      })
      .then(event => {
        const playersForSummary = this.getPlayersForSummary(event);
        this.setState({
          event: event,
          isLoading: false,
          isEditPositions: isCloseEditMode ? false : this.state.isEditPositions,
          playersForSummary: playersForSummary,
          activeTeamIndex: 0
        });
      })
      .catch(error => {
        this.showRequestError(error, 'Participant positions could not be saved. Please try again.');
      });
  };

  onSavePositionsClick = () => {
    const { playersForSummary } = this.state;
    this.savePositions(playersForSummary, true, true);
  };

  onEditPositionsClick = () => {
    this.setState({
      isEditPositions: true
    });
  };

  onChangeTeam = event => {
    const { teamsForSummary } = this.state;
    const teamId = event.target.value;
    const currentTeamIndex = teamsForSummary.findIndex(team => team.teamId === teamId);

    this.setState({
      activeTeamIndex: currentTeamIndex
    });
  };

  onChangeIsSubPlayer = (event, playerId: string): void => {
    const isSub = event.target.checked;
    const { playersForSummary, event: schoolEvent } = this.state;
    const currentPlayersForSummary =
      playersForSummary.length > 0 ? playersForSummary : this.getPlayersForSummary(schoolEvent);
    const playerIndex = currentPlayersForSummary.findIndex(playerForSummary => playerForSummary.playerId === playerId);

    if (playerIndex === -1) {
      return;
    }

    const nextPlayersForSummary = [...currentPlayersForSummary];
    nextPlayersForSummary[playerIndex].isSub = isSub;

    this.setState(
      {
        playersForSummary: nextPlayersForSummary
      },
      () => {
        this.savePositions(nextPlayersForSummary);
      }
    );
  };

  onChangeIsCaptainPlayer = (event, playerId) => {
    const isCaptain = event.target.checked;
    const { playersForSummary, event: schoolEvent } = this.state;
    const currentPlayersForSummary =
      playersForSummary.length > 0 ? playersForSummary : this.getPlayersForSummary(schoolEvent);
    const playerIndex = currentPlayersForSummary.findIndex(playerForSummary => playerForSummary.playerId === playerId);

    if (playerIndex === -1) {
      return;
    }

    const nextPlayersForSummary = [...currentPlayersForSummary];

    if (isCaptain) {
      const teamId = currentPlayersForSummary[playerIndex].teamId;
      const oldCaptainIndex = currentPlayersForSummary.findIndex(
        player => player.teamId === teamId && player.isCaptain
      );

      if (oldCaptainIndex !== -1) {
        nextPlayersForSummary[oldCaptainIndex].isCaptain = false;
      }
      nextPlayersForSummary[playerIndex].isViceCaptain = false;
    }

    nextPlayersForSummary[playerIndex].isCaptain = isCaptain;

    this.setState(
      {
        playersForSummary: nextPlayersForSummary
      },
      () => {
        this.savePositions(nextPlayersForSummary);
      }
    );
  };

  onChangeIsViceCaptainPlayer = (event, playerId) => {
    const isViceCaptain = event.target.checked;
    const { playersForSummary, event: schoolEvent } = this.state;
    const currentPlayersForSummary =
      playersForSummary.length > 0 ? playersForSummary : this.getPlayersForSummary(schoolEvent);
    const playerIndex = currentPlayersForSummary.findIndex(player => player.playerId === playerId);
    if (playerIndex === -1) return;
    const nextPlayersForSummary = [...currentPlayersForSummary];
    nextPlayersForSummary[playerIndex] = {
      ...nextPlayersForSummary[playerIndex],
      isViceCaptain,
      ...(isViceCaptain ? { isCaptain: false } : {})
    };
    this.setState({ playersForSummary: nextPlayersForSummary }, () => this.savePositions(nextPlayersForSummary));
  };

  onChangePositionPlayer = (event, playerId: string): void => {
    const positionValue = event.target.value;

    const { playersForSummary } = this.state;
    const playerIndex = playersForSummary.findIndex(playerForSummary => playerForSummary.playerId === playerId);

    const nextPlayersForSummary = [...playersForSummary];
    nextPlayersForSummary[playerIndex].positionId = positionValue;

    this.setState({
      playersForSummary: nextPlayersForSummary
    });
  };

  getPlayersForSummary(event: SchoolEvent): SchoolEventPlayerSummary[] {
    const { user } = this.props;
    const { activeSchoolId } = user;

    const schoolPlayers = getEventPlayers(event, activeSchoolId);

    return schoolPlayers.map(schoolPlayer => {
      const { userId, permissionId, firstName, lastName, form, id, teamId } = schoolPlayer;
      const isFormExist = typeof form !== 'undefined';
      const formName = isFormExist ? form.name : '';

      const playerFromEvent = event.players.find(
        player => player.userId === userId && player.permissionId === permissionId
      );

      const positionId = typeof playerFromEvent !== 'undefined' ? playerFromEvent.positionId : '';
      const isCaptain = typeof playerFromEvent !== 'undefined' ? playerFromEvent.isCaptain : false;
      const isViceCaptain = typeof playerFromEvent !== 'undefined' ? playerFromEvent.isViceCaptain : false;
      const isSub = typeof playerFromEvent !== 'undefined' ? playerFromEvent.sub : false;

      return {
        name: `${firstName} ${lastName}`,
        playerId: id,
        userId: userId,
        permissionId: permissionId,
        avatar: propz.get(schoolPlayer, ['avatar'], ''),
        form: formName,
        positionId: positionId,
        isCaptain: isCaptain,
        isViceCaptain: isViceCaptain,
        isSub: isSub,
        teamId: teamId
      };
    });
  }

  getTeamsForSummary(): SchoolEventTeamSummary[] {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { event } = this.state;

    return event.teamsData
      .filter(team => team.schoolId === activeSchoolId)
      .map(team => ({
        teamName: team.name,
        teamId: team.id,
        houseName: isHousesEvent(event) ? team.house.name : undefined
      }));
  }

  onCloseEventJobClick = event => {
    event?.preventDefault();

    this.setState({
      isCreateEventJobModalOpen: false,
      eventTaskIndex: 0
    });
  };

  onChangeEventAttendanceComment = (
    field: 'publicComment' | 'internalComment',
    value: string,
    player: SchoolEventIndividualData | SchoolEventTeamDataPlayer
  ): void => {
    const { attendancePlayers } = this.state;

    const attendanceIndex = attendancePlayers.findIndex(
      attendance =>
        String(attendance.userId) === String(player.userId) &&
        String(attendance.permissionId) === String(player.permissionId)
    );

    let nextAttendancePlayers;

    if (attendanceIndex === -1) {
      nextAttendancePlayers = [
        ...attendancePlayers,
        {
          userId: player.userId,
          permissionId: player.permissionId,
          isAttendance: true,
          [field]: value
        }
      ];
    } else {
      nextAttendancePlayers = attendancePlayers.map((a, i) => (i === attendanceIndex ? { ...a, [field]: value } : a));
    }

    this.setState({ attendancePlayers: nextAttendancePlayers });
  };

  renderEventJobForm(): React.ReactNode {
    const { isCreateEventJobModalOpen, eventTasks, eventTaskIndex, event } = this.state;
    const { user } = this.props;

    const modalText = eventTaskIndex === -1 ? 'Create job' : 'Edit job';
    return (
      <SimpleModal
        isOpen={isCreateEventJobModalOpen}
        title={modalText}
        onCloseClick={() => this.onCloseEventJobClick(undefined)}
        showFooter={false}
        customClass="eventJobModal"
        dialogStyle={{ maxWidth: 680 }}
      >
        <SchoolEventJobForm
          user={user}
          schoolEvent={event}
          eventTasks={eventTasks}
          eventTaskIndex={eventTaskIndex}
          onCancel={this.onCloseEventJobClick}
          onSubmit={this.onSubmitEventJobForm}
        />
      </SimpleModal>
    );
  }

  onSubmitEventJobForm = data => {
    const { user } = this.props;
    const { eventTaskIndex, eventTasks, event, reports, consents } = this.state;
    const { id } = event;

    this.setState({
      isLoading: true,
      isCreateEventJobModalOpen: false
    });

    const { players, ...rest } = data;

    const dataToSubmit = {
      ...rest,
      assignees: players
    };
    if (eventTaskIndex !== -1) {
      const activeTaskId = eventTasks[eventTaskIndex].id;
      const isExistReports = reports.length > 0;
      const isExistConsents = consents.length > 0;

      editEventTasks(user, id, activeTaskId, dataToSubmit)
        .then(res => getEventTasks(user, id))
        .then(eventTasks => {
          const eventTab = this.getVisibleTabs(event, isExistReports, isExistConsents);
          const tabIndex = eventTab.indexOf(TABS.JOBS);
          this.setState({
            currentTabIndex: tabIndex,
            eventTasks: eventTasks,
            isCreateEventJobModalOpen: false,
            isLoading: false
          });
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    } else {
      createEventTasks(user, id, dataToSubmit)
        .then(task => {
          const tasks = [...eventTasks];
          tasks.push(task);
          this.setState({
            eventTasks: tasks,
            isLoading: false
          });
        })
        .catch(error => {
          const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
          console.error(error);
          this.setState({
            isCreateEventJobModalOpen: false,
            isLoading: false,
            errorMessage: errorText,
            isErrorModalOpen: true
          });
        });
    }
  };

  renderDeleteJobModal() {
    const { isDeleteJobModalOpen, eventTasks, eventTaskIndex } = this.state;
    const jobText = propz.get(eventTasks, [eventTaskIndex, 'text'], 'this job');

    return (
      <SimpleModal
        isOpen={isDeleteJobModalOpen}
        title="Delete job?"
        body={
          <div className="eventJobDelete__body">
            <p>This will permanently remove the job:</p>
            <div className="eventJobDelete__job">{jobText}</div>
            <p>The assigned participants will no longer see this responsibility.</p>
          </div>
        }
        buttonText="Delete job"
        buttonCancelText="Keep job"
        onButtonClick={this.onDeleteJobClick}
        onCloseClick={this.deleteJobModalClose}
        customClass="eventJobDelete"
        bodyClassName="eventJobDelete__bodyWrap"
        isBodyBold={false}
        dialogStyle={{ maxWidth: 520 }}
      />
    );
  }

  updateEventDetails = (data, editMode) => {
    const { user, reloadEvent } = this.props;
    const { event, currentTabIndex } = this.state;
    const { id } = event;

    this.setState({
      isLoading: true,
      isEditEventDetailsModalOpen: false
    });

    const singleEditMode = editMode === CLUB_EVENT_EDIT_MODE.SINGLE;
    const getEditEventService = singleEditMode
      ? updateSchoolEventDetails(user, event.id, data)
      : updateGroupSchoolEventDetails(user, event.id, data);

    getEditEventService
      .then(res => {
        reloadEvent(currentTabIndex);
      })
      .catch(error => {
        const errorText = propz.get(error, ['response', 'data', 'details', 'text'], '');
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: errorText,
          isErrorModalOpen: true
        });
      });
  };

  editEventDetailsModalClose = () => {
    this.setState({
      isEditEventDetailsModalOpen: false
    });
  };

  renderEventDetailsForm(): React.ReactNode {
    const { isEditEventDetailsModalOpen, eventDetails, event } = this.state;
    const { user } = this.props;
    const { id } = event;
    return (
      <SimpleModal
        customClass="mSchoolEventDetailsFormWidth"
        bodyClassName="mSchoolEventDetailsFormBody"
        isOpen={isEditEventDetailsModalOpen}
        title={'Event details'}
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.editEventDetailsModalClose}
        dialogStyle={{ maxWidth: 960 }}
      >
        <SchoolEventDetailsForm
          eventId={id}
          user={user}
          onSubmit={this.updateEventDetails}
          onCancel={this.editEventDetailsModalClose}
          eventsDetails={eventDetails}
          event={event}
        />
      </SimpleModal>
    );
  }

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      >
        <pre>{errorMessage}</pre>
      </SimpleModal>
    );
  }

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  onDeletePhotoClick = (photoId: string) => {
    const { user, eventInitial } = this.props;
    const { id } = eventInitial;
    this.setState({
      isLoading: true
    });

    deleteEventPhoto(user, id, photoId)
      .then(res => getAllEventPhotos(user, id))
      .then(photos => {
        this.setState({
          isLoading: false,
          photos
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The photo could not be deleted. Please try again.');
      });
  };

  onDeleteVideoClick = (videoId: string) => {
    const { user, eventInitial } = this.props;
    const { id } = eventInitial;
    this.setState({
      isLoading: true
    });

    deleteEventVideo(user, id, videoId)
      .then(res => getAllEventVideos(user, id))
      .then(videos => {
        this.setState({
          isLoading: false,
          videos
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The video could not be deleted. Please try again.');
      });
  };

  onAddPhotoClick = eventDescriptor => {
    let event;
    //This is true only for IE,firefox
    //Dirty hack from https://codeproject.com/Tips/893254/JavaScript-Triggering-Event-Manually-in-Internet-E
    //However, MDN recommend use very similar polyfill https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#Polyfill
    if (document.createEvent) {
      // To create a mouse event , first we need to create an event and then initialize it.
      event = document.createEvent('MouseEvent');
      event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
      event = new MouseEvent('click');
    }
    this.photoFileInputRef.dispatchEvent(event);
    eventDescriptor.stopPropagation();
  };

  //it may come in handy

  onAddVideoClick = eventDescriptor => {
    let event;
    //This is true only for IE,firefox
    //Dirty hack from https://codeproject.com/Tips/893254/JavaScript-Triggering-Event-Manually-in-Internet-E
    //However, MDN recommend use very similar polyfill https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#Polyfill
    if (document.createEvent) {
      // To create a mouse event , first we need to create an event and then initialize it.
      event = document.createEvent('MouseEvent');
      event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
      event = new MouseEvent('click');
    }
    this.videoFileInputRef.dispatchEvent(event);
    eventDescriptor.stopPropagation();
  };

  onPhotoFileChange = event => {
    const { user, eventInitial } = this.props;
    const { id } = eventInitial;
    const image = event.target.files[0];

    const { activeSchool } = user;
    const photoAccessPreset = propz.get(activeSchool, ['photoAccessPreset'], ACCESS_PRESET.PRIVATE);

    this.setState({
      isLoading: true
    });

    uploadImage(user, image)
      .then(response => {
        const picUrl = `${window.apiImg}/images/${response.key}`;
        const data = {
          picUrl: picUrl,
          originalFileName: image.name,
          accessPreset: photoAccessPreset
        };
        return addEventPhoto(user, id, data);
      })
      .then(res => getAllEventPhotos(user, id))
      .then(photos => {
        this.setState({
          isLoading: false,
          photos: photos
        });
      })
      .catch(error => {
        this.showRequestError(error, 'The photo could not be uploaded. Please try again.');
      });
  };

  onVideoFileChange = event => {
    const { user, eventInitial } = this.props;
    const { id } = eventInitial;
    const video = event.target.files[0];
    const { name } = video;
    const safeName = getSafeFileName(name);

    const { activeSchool } = user;
    const photoAccessPreset = propz.get(activeSchool, ['photoAccessPreset'], ACCESS_PRESET.PRIVATE);

    this.setState({
      isLoading: true
    });

    const promises = [getVideoConfig(user), getKey(user)];

    let s3, folderKey, folderName, videoFullName, bucket;

    BPromise.all(promises)
      .then(([videoConfig, keyObj]) => {
        const { accessKey, secretAccessKey, bucketRegion } = videoConfig;
        bucket = videoConfig.bucketName;

        s3 = new S3({
          region: bucketRegion,
          credentials: {
            accessKeyId: accessKey,
            secretAccessKey: secretAccessKey
          }
        });

        folderKey = keyObj.key;
        folderName = `orig/${folderKey}/`;
        videoFullName = folderName + safeName;

        return s3.putObject({ Key: folderName, Bucket: bucket }).promise();
      })
      .then(res => {
        return s3.putObject({ Key: videoFullName, Bucket: bucket, Body: video }).promise();
      })
      .then(res => {
        const data = {
          key: folderKey,
          fileName: safeName,
          bucketName: bucket
        };
        return addConvertJob(user, data);
      })
      .then(jobObj => {
        const job = jobObj.Job;
        const jobId = job.Id;

        const data = {
          fileName: safeName,
          key: folderKey,
          jobId: jobId,
          accessPreset: photoAccessPreset
        };

        return addEventVideo(user, id, data);
      })
      .then(res => getAllEventVideos(user, id))
      .then(videos => {
        this.setState({
          isLoading: false,
          videos: videos
        });
      })
      .catch(error => {
        console.error(error);
        this.setState({
          isLoading: false,
          errorMessage: JSON.stringify(error),
          isErrorModalOpen: true
        });
      });
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isVenueFormOpen: false
    });
  };

  onViewMapClick = (point): void => {
    this.setState({
      point: point,
      isVenueFormOpen: true
    });
  };

  renderPhotoFileInput() {
    return (
      <input
        className="eAddPhotoButton_fileInput"
        type="file"
        accept="image/*"
        aria-label="Choose a photo"
        onChange={this.onPhotoFileChange}
        ref={input => (this.photoFileInputRef = input)}
      />
    );
  }

  renderVideoFileInput() {
    return (
      <input
        className="eAddVideoButton_fileInput"
        type="file"
        accept="video/*"
        aria-label="Choose a video"
        onChange={this.onVideoFileChange}
        ref={input => (this.videoFileInputRef = input)}
      />
    );
  }

  renderVenueModal() {
    const { user } = this.props;
    const { point } = this.state;
    return (
      <SimpleModal isOpen={this.state.isVenueFormOpen} onButtonClick={this.onCancelButtonClick} title={'Venue'}>
        <VenueView point={point} onOkClick={this.onCancelButtonClick} />
      </SimpleModal>
    );
  }

  private ensureAwardTypesLoaded = async () => {
    if (Object.keys(this.state.awardTypesById).length) return;

    const list: AwardType[] = await getAllAwardTypes(this.props.user);
    const map = list.reduce((acc, t) => {
      acc[t.id] = { name: t.name, picture: t.picture || null };
      return acc;
    }, {} as Record<string, { name: string; picture?: string | null }>);

    this.setState({ awardTypesById: map });
  };

  private renderAwardEditModal() {
    const { isAwardEditOpen, awardEditError, awardFormDraft } = this.state;

    return (
      <SimpleModal
        isOpen={isAwardEditOpen}
        title="Edit award event"
        customClass="modal-xl myAwardTypeModal eAwardEditModal"
        bodyClassName="eAwardEditModal__body"
        showFooter={false}
        isBodyBold={false}
        onCloseClick={this.onAwardEditCancel}
      >
        {awardEditError && <div className="eAwardEditModal__error">{awardEditError}</div>}
        {awardFormDraft && (
          <AwardEventForm
            initialValues={awardFormDraft as AwardEventFormValues}
            user={this.props.user}
            onCancel={this.onAwardEditCancel}
            onSubmit={this.onAwardEditSubmit}
          />
        )}
      </SimpleModal>
    );
  }

  private renderAwardDeleteModal() {
    const { isAwardDeleteOpen, awardDeleting, awardTypesById } = this.state;
    const typeId = (awardDeleting as any)?.awardTypeId || (awardDeleting as any)?.awardType?.id;
    const title = typeId ? awardTypesById[typeId]?.name || 'Award' : 'Award';

    return (
      <SimpleModal
        isOpen={isAwardDeleteOpen}
        customClass="eAwardDeleteModal"
        title="Delete award event"
        body={`Are you sure you want to remove award event for "${title}"?`}
        buttonText="Delete"
        buttonCancelText="Cancel"
        onButtonClick={this.onAwardDeleteConfirm}
        onCloseClick={this.onAwardDeleteClose}
      />
    );
  }

  render() {
    const {
      currentTabIndex,
      isLoading,
      isErrorModalOpen,
      isEditEventDetailsModalOpen,
      isCreateEventJobModalOpen,
      isVenueFormOpen,
      isAttendanceLogModalOpen,
      event,
      reports,
      consents,
      isEditPositions
    } = this.state;
    const { user } = this.props;
    const { activeSchoolId } = user;
    const isExistReports = reports.length > 0;
    const isExistConsents = consents.length > 0;
    const tabs = this.getVisibleTabs(event, isExistReports, isExistConsents);
    const contentTabs = this.getContentTabs();
    const currentTab = tabs[currentTabIndex];

    if (isLoading) {
      return <Loader />;
    }

    const players = getEventPlayers(event, activeSchoolId);

    const isShowAddJobButton = currentTab === TABS.JOBS;
    const isPlayersExist = players.length > 0;

    const isShowEditPositionsButton = !isEditPositions && !isClubEvent(event) && currentTab === TABS.POSITIONS;
    const isShowSavePositionsButton = isEditPositions && !isClubEvent(event) && currentTab === TABS.POSITIONS;
    const isPositionsTab = currentTab === TABS.POSITIONS;

    const classes =
      isErrorModalOpen ||
      isEditEventDetailsModalOpen ||
      isCreateEventJobModalOpen ||
      isVenueFormOpen ||
      isAttendanceLogModalOpen
        ? 'mt-3 modal-open'
        : 'mt-3';

    return (
      <div className={classes}>
        {this.renderEventJobForm()}
        {this.renderEventDetailsForm()}
        {this.renderDeleteJobModal()}
        {this.renderSendingError()}
        {this.renderPhotoFileInput()}
        {this.renderVideoFileInput()}
        {this.renderVenueModal()}
        {this.renderAwardEditModal()}
        {this.renderAwardDeleteModal()}
        {this.renderGrantParticipantsModal()}
        {this.renderGrantAwardModal()}
        {this.renderNoHouseWarning()}
        {this.renderPartialHouseWarning()}
        <AttendanceLogModal
          user={user}
          eventId={event.id}
          isOpen={isAttendanceLogModalOpen}
          onClose={this.onCloseAttendanceLog}
        />
        <SchoolEventGroupedTabs onTabClick={this.onTabClick} tabs={tabs} currentTabIndex={currentTabIndex} communicationsUser={user} communicationsEventId={event.id}>
          {isShowAddJobButton && (
            <div className="eventJobsTopBar">
              <Button
                onClick={this.onAddEventJobClick}
                text="Add job"
                customClass="sit-btn sit-btn--primary sit-btn--sm"
              />
            </div>
          )}
          {isPositionsTab && (
            <div className="eEventPositionsTopBar">
              <div>
                <h2 className="eEventPositionsTopBar__title">Positions</h2>
                <div className="eEventPositionsTopBar__subtitle">Assign positions and squad roles for this event.</div>
              </div>
              {isShowEditPositionsButton && (
                <Button
                  onClick={this.onEditPositionsClick}
                  text={'Edit positions'}
                  customClass={'sit-btn sit-btn--primary sit-btn--sm eEventParticipantsTopEditButton'}
                  disabled={!isPlayersExist}
                />
              )}
              {isShowSavePositionsButton && (
                <Button
                  onClick={this.onSavePositionsClick}
                  text={'Save positions'}
                  customClass={'sit-btn sit-btn--primary sit-btn--sm eEventParticipantsTopEditButton'}
                  disabled={!isPlayersExist}
                />
              )}
            </div>
          )}
          {contentTabs}
        </SchoolEventGroupedTabs>
      </div>
    );
  }
}
